import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class UploadDocumentationsService {

    constructor(private httpClient: HttpClient) { }

    uploadDoc(uploads: FormData) {
        return this.httpClient.post('api/offers/uploaddocuments', uploads)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    uploadUserDoc(uploads: FormData) {
        return this.httpClient.post('api/offers/useruploaddocuments', uploads)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

}